import React from 'react';
import { styled } from '@mui/material';
import t from '@/utils/translate';

const nFormat = new Intl.NumberFormat();

const MemoryMeasurementUnit = styled('em')({
  color: '#6B778C',
  fontStyle: 'normal',
});

export default ({ value }: { value: number }) => {
  if (typeof value !== 'number') {
    value = parseInt(value);
  }
  let v = value;
  let unit = 'GB';
  for (const u of [ 'B', 'KB', 'MB' ]) {
    if (v < 1000) {
      unit = u;
      break;
    }
    v = v / 1000;
  }
  return <span title={`${nFormat.format(value)} ${t('units.information.B')}`}>
    {v.toFixed(2)}&nbsp;<MemoryMeasurementUnit>{t(`units.information.${unit}`)}</MemoryMeasurementUnit>
  </span>
};
